// Google Analytics 4 utility functions

declare global {
  interface Window {
    gtag: (...args: any[]) => void;
  }
}

export const GA_MEASUREMENT_ID = import.meta.env.VITE_GA_MEASUREMENT_ID || 'G-0E9L7M18P7';

// Track custom events
export const trackEvent = (eventName: string, parameters?: Record<string, any>) => {
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag('event', eventName, parameters);
  }
};

// Track button clicks
export const trackButtonClick = (buttonName: string, location?: string) => {
  trackEvent('button_click', {
    button_name: buttonName,
    location: location || 'homepage',
    event_category: 'engagement',
    event_label: `${buttonName}_${location || 'homepage'}`
  });
};

// Track audit button clicks specifically
export const trackAuditButtonClick = (location: string = 'homepage') => {
  trackButtonClick('start_audit', location);
};

// Track audit completion
export const trackAuditCompletion = (companyName?: string, industry?: string) => {
  trackEvent('audit_completed', {
    event_category: 'conversion',
    event_label: 'audit_form_submitted',
    company_name: companyName || 'unknown',
    industry: industry || 'unknown',
    completion_timestamp: new Date().toISOString()
  });
};

// Track audit results page view
export const trackAuditResultsView = (companyName?: string, score?: number) => {
  trackEvent('audit_results_viewed', {
    event_category: 'engagement',
    event_label: 'results_page_loaded',
    company_name: companyName || 'unknown',
    audit_score: score || 0,
    view_timestamp: new Date().toISOString()
  });
};

// Track result page actions
export const trackBackToHome = (companyName?: string, score?: number) => {
  trackEvent('back_to_home_clicked', {
    event_category: 'navigation',
    event_label: 'results_to_homepage',
    company_name: companyName || 'unknown',
    audit_score: score || 0,
    click_timestamp: new Date().toISOString()
  });
};

export const trackGenerateReport = (companyName?: string, score?: number) => {
  trackEvent('generate_report_clicked', {
    event_category: 'conversion',
    event_label: 'pdf_report_requested',
    company_name: companyName || 'unknown',
    audit_score: score || 0,
    click_timestamp: new Date().toISOString()
  });
};

export const trackDownloadReport = (companyName?: string, score?: number) => {
  trackEvent('report_downloaded', {
    event_category: 'conversion',
    event_label: 'pdf_report_downloaded',
    company_name: companyName || 'unknown',
    audit_score: score || 0,
    download_timestamp: new Date().toISOString()
  });
};

export const trackEmailReport = (companyName?: string, score?: number) => {
  trackEvent('email_report_clicked', {
    event_category: 'conversion',
    event_label: 'email_report_requested',
    company_name: companyName || 'unknown',
    audit_score: score || 0,
    click_timestamp: new Date().toISOString()
  });
};

// Track page views
export const trackPageView = (pagePath: string, pageTitle?: string) => {
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag('config', GA_MEASUREMENT_ID, {
      page_path: pagePath,
      page_title: pageTitle
    });
  }
};
